module.exports = __webpack_public_path__ + "images/saaremaa/ms-icon-150x150.png";